import { c as _c } from "react/compiler-runtime";
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { InitialsAvatar } from '../../atoms/initials-avatar/initials-avatar.tsx';
import { useSupporterIdentity } from './supporter-identity.logic.ts';
export const SupporterIdentity: React.FC<{
  variant: 'full' | 'minimal' | 'dropdown';
  size?: 'sm' | 'md' | 'lg';
  notificationCount?: number;
  className?: string;
}> = t0 => {
  const $ = _c(34);
  const {
    variant,
    size,
    notificationCount,
    className
  } = t0;
  const {
    email,
    initials,
    name
  } = useSupporterIdentity();
  if (variant === "minimal") {
    let t1;
    if ($[0] !== className) {
      t1 = cn("SupporterIdentity", className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== initials || $[3] !== notificationCount || $[4] !== size) {
      t2 = <InitialsAvatar initials={initials} notificationCount={notificationCount} size={size} />;
      $[2] = initials;
      $[3] = notificationCount;
      $[4] = size;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    let t3;
    if ($[6] !== t1 || $[7] !== t2) {
      t3 = <div className={t1}>{t2}</div>;
      $[6] = t1;
      $[7] = t2;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    return t3;
  }
  if (variant === "dropdown") {
    let t1;
    if ($[9] !== className) {
      t1 = cn("SupporterIdentity SupporterIdentity--dropdown flex flex-row gap-snug-xl items-center", className);
      $[9] = className;
      $[10] = t1;
    } else {
      t1 = $[10];
    }
    let t2;
    if ($[11] !== initials || $[12] !== size) {
      t2 = <InitialsAvatar initials={initials} size={size} />;
      $[11] = initials;
      $[12] = size;
      $[13] = t2;
    } else {
      t2 = $[13];
    }
    let t3;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <ArkIcon iconName="chevron-down" size="20" className="label-neutral-mild lg:hidden" />;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    let t4;
    if ($[15] !== t1 || $[16] !== t2) {
      t4 = <div className={t1}>{t2}{t3}</div>;
      $[15] = t1;
      $[16] = t2;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    return t4;
  }
  let t1;
  if ($[18] !== className) {
    t1 = cn("SupporterIdentity flex gap-comfy-xs px-comfy-sm lg:px-comfy-xs", className);
    $[18] = className;
    $[19] = t1;
  } else {
    t1 = $[19];
  }
  let t2;
  if ($[20] !== initials || $[21] !== notificationCount) {
    t2 = <InitialsAvatar initials={initials} size="md" className="shrink-0" notificationCount={notificationCount} />;
    $[20] = initials;
    $[21] = notificationCount;
    $[22] = t2;
  } else {
    t2 = $[22];
  }
  let t3;
  if ($[23] !== name) {
    t3 = name && <span className="SupporterIdentity__name label-xl label-potent overflow-hidden m-0 text-wrap-nowrap text-ellipsis">{name}</span>;
    $[23] = name;
    $[24] = t3;
  } else {
    t3 = $[24];
  }
  let t4;
  if ($[25] !== email) {
    t4 = email && <span className="SupporterIdentity__email label-md label-moderate overflow-hidden text-wrap-nowrap text-ellipsis">{email}</span>;
    $[25] = email;
    $[26] = t4;
  } else {
    t4 = $[26];
  }
  let t5;
  if ($[27] !== t3 || $[28] !== t4) {
    t5 = <div className="flex flex-col overflow-hidden justify-center">{t3}{t4}</div>;
    $[27] = t3;
    $[28] = t4;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  let t6;
  if ($[30] !== t1 || $[31] !== t2 || $[32] !== t5) {
    t6 = <div className={t1}>{t2}{t5}</div>;
    $[30] = t1;
    $[31] = t2;
    $[32] = t5;
    $[33] = t6;
  } else {
    t6 = $[33];
  }
  return t6;
};